import React, { useState, useEffect, useLayoutEffect } from 'react';
import { 
  AppBar, Toolbar, IconButton, Box,
  Menu, MenuItem, Drawer, Typography,
  List, ListItemButton, ListItemText,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CloseIcon from '@mui/icons-material/Close';
import { Link, useRouteMatch } from 'react-router-dom';
import logo from '../assets/images/skyguide_logo.png';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, SCHOOL_OF_COMPETENCE_PORTAL } from './portal/portalConfigs';

const classes = {
  appBar: {
    backgroundColor: '#1e283c',
    padding: '0 10%',
    '@media (max-width:768px)': {
      padding: '0 10px',
    },
  },
  padding: {
    paddingRight: 30,
    cursor: 'pointer',
    fontSize: '16px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: '400',
  },
  sideBarIcon: {
    padding: 0,
    color: 'white',
    fontSize: '30px',
    cursor: 'pointer',
    width: '10%',
    position: 'absolute',
    left: '8px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  mobileBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  logoMobile: {
    display: 'flex',
  },
  menu: {
    marginLeft: 'calc(10% + 30px)',
  },
  languageIcon: {
    color: "white",
    height: "100%",
    width: 'auto',
    alignSelf: 'center',
  },
  languageMenu: {
    display: 'flex',
    flexDirection: 'row',
    textTransform: 'uppercase',
  },
  languageItem: {
    fontWeight: 'bold',
    color: '#2850a0',
  }
};
function Navbar(props) {
  const [drawerActive, setDrawerActive] = useState(false);
  const[open, setOpen] = useState(false);
	const[anchorEl, setAnchorEl] = useState(null);
  const { t, i18n } = useTranslation();
  const isSchoolOfCompetence = Boolean(useRouteMatch({ path: '/schoolofcompetence', exact: true }));
  const routeLanguages = isSchoolOfCompetence ? SCHOOL_OF_COMPETENCE_PORTAL.languages : LANGUAGES;

  // School of Competence is not offered in Italian: it shows English instead
  useLayoutEffect(() => {
    const savedLanguage = localStorage.getItem('lang') || 'en';
    const isAvailable = routeLanguages.some(({ code }) => code === savedLanguage);
    const language = isAvailable ? savedLanguage : 'en';
    if (language !== i18n.language) i18n.changeLanguage(language);
  }, [routeLanguages, i18n]);

  useEffect(() => {
    if (window.innerWidth <= 600) {
      setDrawerActive(true);
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 600) {
        setDrawerActive(true);
      } else {
        setDrawerActive(false);
      }
    });
  }, []);

	const handleClose = () => {
		if (!drawerActive) setAnchorEl(null);
    setOpen(false);
	};
	const handleChangeLanguage = (lang) => {
		i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
		handleClose();
	};

  const languages = routeLanguages.map(({ code, labelKey }) => ({ code, label: t(labelKey) }));

	const languageMenu = () => {
		return (
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin = {{
					vertical: 'top',
					horizontal: 'left',
				}}
        sx={classes.menu}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
        <Box
          sx={classes.languageMenu}
        >
          {languages.map(({ code }) => (
            <MenuItem
              key={code}
              sx={(code === i18n.language) ? classes.languageItem : {}}
              onClick={() => handleChangeLanguage(code)}
            >
              {code}
            </MenuItem>
          ))}
          <MenuItem>
            <CloseIcon onClick={() => handleClose()}/>
          </MenuItem>
        </Box>
			</Menu>
		);
	};

  const languageMobileMenu = () => {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            {t('filters.language.title')}
          </Typography>
          <List>
            {languages.map(({ code, label }) => (
              <ListItemButton
                key={code}
                selected={i18n.language === code}
                onClick={() => handleChangeLanguage(code)}
              >
                <ListItemText
                  primary={label}
                  sx={(code === i18n.language) ? classes.languageItem : {}}
                />
              </ListItemButton>
            ))}
          </List>
        </Box>

      </Drawer>
    );
  };

  //Small Screens
  let createDrawer = () => {
    return (
      <div>
        <AppBar sx={classes.appBar} position='static'>
          <Toolbar>
            <Box sx={classes.mobileBar}>
              <LanguageIcon
                sx={classes.sideBarIcon}
                onClick={() => {
                  setOpen(true);
                }}
              />
              <Link style={classes.logoMobile} to='/'>
                <img style={{ height: '40px' }} src={logo} alt='lo'></img>
              </Link>
            </Box>
            {languageMobileMenu()}
          </Toolbar>
        </AppBar>
      </div>
    );
  };

  //Larger Screens
  let destroyDrawer = () => {
    return (
      <AppBar sx={classes.appBar} position='sticky'>
        <Toolbar style={{ padding: 'unset' }}>
          <Box sx={classes.headerContainer}>
            <IconButton sx={classes.languageIcon} aria-label="set language" onClick={() => setOpen(true)}>
              <LanguageIcon
                sx={{ fontSize: '32px' }}
              />
            </IconButton>
            <a href='/'>
              <img src={logo} alt="logo" />
            </a>
          </Box>
          {languageMenu()}
        </Toolbar>
      </AppBar>
    );
  };
  return <div>{drawerActive ? createDrawer() : destroyDrawer()}</div>;
}

export default (Navbar);
